export const GET_PROFILE = `{
    profile {
      accountID
      account {
        id
        name
        ownerId
        customerId
        createdAt
        updatedAt
        tier
        cycle
        alwaysFree
        customer {
          id
        }
      }
      createdAt
      fullName
      id
      isActiveUser
      memberships {
        accessLevel
        id
        isActive
        teamId
        userId
      }
      teamMembers {
        accessLevel
        id
        isActive
        teamId
        userId
      }
      personalTeamId
      primaryEmail
      teams {
        accountID
        color
        createdAt
        id
        isPersonal
        name
        ownerId
        updatedAt
        trialEnd
        trialEndTs
        teamOwnerEmail
        teamOwnerName
      }
      role
      updatedAt
      verified
      onboardingStep
      timezone
      weeklyReports,
      reminders,
      announcements,
      education,
      oAuthTokens {
        id,
        service,
        clientName,
        clientDescription,
        homepage,
        scopes,
        imageSrc,
      },
      webhookSubscriptions {
        id,
        targetUrl,
        eventName,
      },  
    }
}`



// WEBPACK FOOTER //
// ./src/util/profile_graphql_queries.js